import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';

import DesktopLayerPopup from '../../common/DesktopLayerPopup';
import { CommonUtil } from '../../common/CommonUtil';

import { MembershipName } from '../../../library/constants/Code';
import UserServices from '../../../library/services/UserServices';
import ExperienceInjector from '../../../library/payment/ExperienceInjector';
import ParentsUtil from '../../../library/util/ParentsUtil';
import ButtonBlockUtil from '../../../library/util/ButtonBlockUtil';

import WinkFreeStudyNotLoginStep02 from './WinkFreeStudyNotLoginStep02';

import { api, service } from './config';
import { fetch } from '../../../redux/actions';
import { routes } from '../../../constants/routes';
import { useAgreement } from '../../trial-apply/hooks/useAgreement';
import ShippingAddressNotLogin from './components/ShippingAddressNotLogin';
import AgreementSection from './components/AgreementSection';
import styled from '@emotion/styled';
import { TrialApplyDescription } from '../../trial-apply/components/TrialApplyDescription';
import { useMemberJoin } from '@/hooks';
import { modifyInnerParentCategoryTag } from '@/library/memberjoin/MemberJoinAction';
import {
    getTemporaryInformationOptionalAgreementParams,
    TERMS_AGREEMENT_CONTEXT,
    withTermsAgreementContext,
} from '@/library/util/TermsAgreementUtil';
import { FREE_STUDY_DUPLICATE_ACTION } from './utils/freeStudyDuplicateFallback';

const NewBtnArea = styled.div`
    padding: 20px 0;
    text-align: center;
`;
const NewBtn = styled.a`
    display: inline-block;
    box-sizing: border-box;
    padding: 0 16px;
    min-width: 150px;
    height: 50px;
    text-align: center;
    line-height: 52px;
    margin: 0 5px;
    color: #222;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    cursor: pointer;

    ${({ confirm }) =>
        confirm &&
        `
        background: #09bad5;
        border-color: #09bad5;
        color: #fff;
    `}
`;

const mapDispatchToProps = (dispatch) => ({
    silentUpdateMultipleList: (list) => dispatch(fetch.silentUpdateMultipleList(list)),
});

const WinkFreeStudyNotLogin = (props) => {
    const {
        todayStudyMap,
        getTodayStudyMap,
        action,
        loginErrorMessage,
        clearMdnToken,
        clearAuthActor,
        logout,
        clearAction,
        mdnToken,
        existAuth,
        auth,
        actor: memberJoinActor,
        modifyAuth,
        createFamilyAndApplyExperience,
        createAuths,
        studentList,
        successApplyExperience,
        deleteDropOut,
        phoneDuplicateCheckAndOneTimePasswordForMemberJoin,
        checkOneTimePasswordForMemberJoin,
    } = useMemberJoin();

    const [curStep, setCurStep] = useState(1);
    const {
        agreement: termsAgreement,
        onCheckBox: onAgreementCheckBox,
        validateAndShowAgreementPopup,
    } = useAgreement();

    const [state, setState] = useState({
        certStatus: {
            onTimePasswordCount: 0,
            mdn_token: '',
            complete: false,
            certificationNumber: '',
        },
        actorId: null,
        isOneMoreRequest: false,
        hasExperiencePreConsultWork: true,
    });

    const studentSeq = useRef(0);
    const buttonBlock = useRef(new ButtonBlockUtil());

    // Sync effect for API loading and default value setup
    useEffect(() => {
        const settingType = 'ApplyingServiceParamSetting';

        props.initDataForNotLogin();

        getTodayStudyMap();

        // 학생 정보 기본값 설정
        const { setStudentInfoList } = props;
        const defaultStudentInfo = {
            kid_name: '',
            kid_gender: 'male',
            kid_birth_year: null,
            kid_birth_month: null,
            kid_birth_day: null,
            checkList: service.getCurrentLevels(null),
        };
        setStudentInfoList([{ key: studentSeq.current, ...defaultStudentInfo }]);

        UserServices.getSettingInfo(settingType, settingType).then((res) => {
            setState((prev) => ({
                ...prev,
                hasExperiencePreConsultWork: res?.data?.data?.has_experience_pre_consult_work ?? true,
            }));
        });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (action === 'passwordResetRequired') {
            DesktopLayerPopup.notice({
                className: 'password-reset-notice',
                showXButton: false,
                message: loginErrorMessage,
                callback: (type) => {
                    if (type === 'CLOSE') {
                        DesktopLayerPopup.resetPassword({
                            showLoginAfterReset: false,
                        });
                    }
                },
            });
        } else if (action === 'accountLocked') {
            DesktopLayerPopup.notice({
                showXButton: false,
                message: loginErrorMessage,
            });
        } else if (action === 'failNoMatchAuthName') {
            DesktopLayerPopup.notice({
                message:
                    '이미 윙크학습에 등록된 회원 정보입니다. </br>' +
                    '윙크 무료학습 신청을 한번 더 원하실 경우, 아래 버튼을 통해 </br>' +
                    '신청해주시기 바랍니다.',
                buttonLabel: '무료학습 한번 더 신청하기',
                callback: (type) => {
                    onClickReApply(type);
                },
            });
        }
        return clearAction;
        // eslint-disable-next-line
    }, [action]);

    // 요청 시 사용할 파라미터 생성
    const getParams = () => {
        const { user_info, studentInfoList } = props;
        const { hasExperiencePreConsultWork } = state;
        const { human_address, human_detail_address, human_postal_code, human_mdn, supporter, register_code } =
            user_info;
        const {
            kid_name = '',
            kid_birth_day,
            kid_birth_month,
            kid_birth_year,
            checkList,
        } = studentInfoList[0] || {};

        const mappedCheckList = service.getMappedCheckList(todayStudyMap, checkList);

        return {
            human_name: user_info.human_name,
            human_mdn,
            mdn_token: mdnToken,
            human_postal_code,
            address: human_address + ' ' + human_detail_address,
            human_address,
            human_detail_address,
            childName: kid_name,
            childIsMale: true,
            childBirth: kid_birth_year + '-' + kid_birth_month + '-' + kid_birth_day,
            checkList: mappedCheckList,
            register_code: register_code,
            parent_category_tag_name: supporter,
            has_experience_pre_consult_work: hasExperiencePreConsultWork,
            request_channel: 'PC_WEB_추가신청',
            regist_date: moment().format('YYYY-MM-DD HH:mm:ss'),
        };
    };

    // 체험신청 요청
    const requestFreeStudy = async (actorId = null, termsAgreementOverride = termsAgreement) => {
        if (existAuth === true && auth?.id) {
            const existParam = {
                ...getParams(),
                actorId,
            };

            const authInfo = {
                human_name: (existParam.human_name || '').trim(),
                human_mdn: existParam.human_mdn,
                human_postal_code: existParam.human_postal_code,
                human_address: existParam.human_address,
                human_detail_address: existParam.human_detail_address,
                data: {
                    ...auth.data,
                    terms_agreement: withTermsAgreementContext(
                        {
                            ...(auth.data?.terms_agreement ?? {}),
                            ...termsAgreementOverride,
                        },
                        TERMS_AGREEMENT_CONTEXT.PC_FREE_STUDY
                    ),
                },
            };
            await UserServices.modifyAuths(auth.id, authInfo);

            if (props.user_info?.supporter?.parent_category_tag_name) {
                await modifyInnerParentCategoryTag(
                    memberJoinActor.id,
                    props.user_info?.supporter?.parent_category_tag_name
                );
            }
            const result = await createFamilyAndApplyExperience({
                ...existParam,
                freeStudyDuplicateFallback: true,
            });
            if (result === FREE_STUDY_DUPLICATE_ACTION) {
                return openDuplicateStudentPopup(termsAgreementOverride);
            }
            success();
            return;
        }

        service.sendLevelChoiceGaEvent(props?.studentInfoList, state.levelChoices);
        const result = await createFamilyAndApplyExperience({
            ...getParams(),
            actorId,
            freeStudyDuplicateFallback: true,
        });
        if (result === FREE_STUDY_DUPLICATE_ACTION) {
            return openDuplicateStudentPopup(termsAgreementOverride);
        }
        success();
    };

    // 신청하기 버튼 핸들러
    const proceedWithApplication = async (termsAgreementOverride = termsAgreement) => {
        const { studentInfoList, user_info } = props;
        const { supporter } = user_info;

        if (!memberJoinActor && !ParentsUtil.validatePhoneNumber(mdnToken)) {
            const { payload } = await createAuths({
                ...getParams(),
                data: {
                    terms_agreement: withTermsAgreementContext(
                        termsAgreementOverride,
                        TERMS_AGREEMENT_CONTEXT.PC_FREE_STUDY
                    ),
                    parent_category_tag_name: supporter,
                },
            });
            const { actor } = payload;
            const { kid_birth_year, kid_birth_month, kid_birth_day } = studentInfoList[0];
            const birthday = `${kid_birth_year}-${kid_birth_month}-${kid_birth_day}`;
            const startDate = CommonUtil.getFreeApplyStartAge();
            const isUnderAgeAndFirst = !moment(birthday).isSameOrBefore(startDate);

            if (studentInfoList.length > 1 || studentInfoList[0].isOneMoreRequest || isUnderAgeAndFirst) {
                let oneMoreRequestVisible = false;
                const tempInfoParams = studentInfoList
                    .filter((studentInfo, idx) => {
                        const studentName = studentInfo?.kid_name?.trim() ?? '';
                        const year = studentInfo?.kid_birth_year ?? '';
                        const month = studentInfo?.kid_birth_month ?? '';
                        const day = studentInfo?.kid_birth_day ?? '';
                        return idx === 0 || studentName || (year && month && day);
                    })
                    .map((studentInfo, idx) => {
                        let requestChannel = studentInfo.isOneMoreRequest ? 'PC_WEB_재신청' : 'PC_WEB';
                        if (idx > 0) requestChannel = `${requestChannel}(형제회원)`;
                        if (idx === 0 && isUnderAgeAndFirst) requestChannel = 'PC_WEB_사전신청';

                        if (studentInfo.isOneMoreRequest) oneMoreRequestVisible = true;

                        return makeTemporaryInformationParams(
                            studentInfo,
                            requestChannel,
                            termsAgreementOverride
                        );
                    });
                if (oneMoreRequestVisible) {
                    DesktopLayerPopup.notice({
                        message:
                            '이미 윙크를 신청한 경험이 있는 아이입니다.</br>' +
                            '아래의 버튼을 누르시면 특별 추가 무료학습 기회를 드립니다.',
                        buttonLabel: '이어서 신청하기',
                        callback: (type) => onClickOneMoreRequest(type, tempInfoParams),
                    });
                }
                return requestTemporaryInformation(tempInfoParams);
            }
            return requestFreeStudy(actor?.id, termsAgreementOverride);
        }
        return requestFreeStudy(memberJoinActor?.id, termsAgreementOverride);
    };

    const onClickConfirm = (e) => {
        e.preventDefault();
        if (buttonBlock.current.isBlocking(2000) === true) return;
        if (!checkFieldsValueStep02()) return false;
        validateAndShowAgreementPopup(proceedWithApplication);
    };

    const makeTemporaryInformationParams = (
        studentInfo,
        requestChannel,
        termsAgreementOverride = termsAgreement
    ) => {
        const { user_info } = props;
        const studentName = studentInfo?.kid_name ?? '';
        const year = studentInfo?.kid_birth_year ?? '';
        const month = studentInfo?.kid_birth_month ?? '';
        const day = studentInfo?.kid_birth_day ?? '';
        const checkList = studentInfo?.checkList ?? {};
        const params = {
            informationType: 'ExperienceReapplication',
            parentAuthHumanName: user_info.human_name.trim(),
            parentAuthHumanMdn: user_info.human_mdn,
            studentAuthHumanName: studentName.trim(),
            studentIsMale: true,
            studentBirthday:
                year && month && day ? moment(`${year}-${month}-${day}`).format('YYYY-MM-DD HH:mm:ss') : undefined,
            studentHumanPostalCode: user_info.human_postal_code,
            studentHumanAddress: user_info.human_address,
            studentHumanDetailAddress: user_info.human_detail_address,
            registeredDate: moment().format('YYYY-MM-DD HH:mm:ss'),
            ...getTemporaryInformationOptionalAgreementParams(
                termsAgreementOverride
            ),
            ...service.getTemporaryInformationLevelParams(checkList),
            requestChannel,
        };

        return params;
    };

    // 1단계 유효성 체크
    const checkFieldsValueStep01 = () => {
        const { user_info } = props;
        const { certStatus } = state;
        const { human_name, human_address, human_detail_address, human_postal_code } = user_info;

        if (!human_name || human_name.trim() === '') {
            DesktopLayerPopup.notice({
                message: '이름을 입력해 주세요',
            });
            return false;
        } else if (!certStatus.complete) {
            DesktopLayerPopup.notice({
                message: '전화번호인증을 완료해 주세요',
            });
            return false;
        } else if (!human_address || !human_postal_code) {
            DesktopLayerPopup.notice({
                message: '우편번호 찾기를 통해<br/> 주소를 입력해 주세요.',
            });
            return false;
        } else if (!human_detail_address || human_detail_address.trim() === '') {
            DesktopLayerPopup.notice({
                message: '상세주소를 입력해 주세요.',
            });
            return false;
        }
        return true;
    };

    // 2단계 유효성 체크
    const checkFieldsValueStep02 = () => {
        const { user_info, studentInfoList } = props;
        const { human_name } = user_info;
        const { kid_name = '', kid_birth_day, kid_birth_month, kid_birth_year } = studentInfoList[0];

        const targetStudent = ParentsUtil.getArrTargetItem(studentList, 'auth_human_name', kid_name);
        if (kid_name === '') {
            DesktopLayerPopup.notice({
                message: '아이의 이름을 입력해 주세요.',
            });
            return false;
        } else if (
            !kid_birth_year ||
            kid_birth_year === '선택' ||
            kid_birth_month === '선택' ||
            kid_birth_day === '선택' ||
            kid_birth_month === '' ||
            kid_birth_day === ''
        ) {
            DesktopLayerPopup.notice({
                message: '아이의 생년월일을 입력해 주세요.',
            });
            return false;
        } else if (human_name.trim() === kid_name.trim()) {
            DesktopLayerPopup.notice({
                message:
                    '학부모님 이름과 아이 이름이 동일합니다. </br>' +
                    '윙크 무료학습 신청을 원하실 경우, 아래 버튼을 통해 신청해주시기 바랍니다.',
                callback: (type) => {
                    onClickReApply(type);
                },
                buttonLabel: '무료체험 한번 더 신청하기',
            });
            return false;
        } else if (targetStudent && targetStudent.auth_detail) {
            if (
                moment(targetStudent.auth_detail.birthday).format('YYYY-MM-DD') ===
                moment(`${kid_birth_year}${kid_birth_month}${kid_birth_day}`).format('YYYY-MM-DD')
            ) {
                //수업중학생
                if (ParentsUtil.isStuding(targetStudent) === true) {
                    if (ParentsUtil.getMembershipString(targetStudent) === MembershipName.체험회원) {
                        buttonBlock.current.stop();
                        DesktopLayerPopup.notice({
                            message: '체험중인 아이입니다.',
                        });
                        return false;
                    }
                    if (ParentsUtil.getMembershipString(targetStudent) === MembershipName.정회원) {
                        buttonBlock.current.stop();
                        DesktopLayerPopup.notice({
                            message: '학습중인 아이입니다.',
                        });
                        return false;
                    }
                }
            }
            buttonBlock.current.stop();
        }
        return true;
    };

    // 무료학습 한번 더 신청하기 버튼 클릭 이벤트
    const onClickReApply = (type) => {
        if (type === 'CLOSE') {
            window.open(
                'https://m.wink.co.kr/client/mobile/simple-apply?source=homepage&medium=reoffer&content=pc',
                '_blank'
            );
        }
    };

    const openDuplicateStudentPopup = (
        termsAgreementOverride = termsAgreement
    ) => {
        const firstStudentInfo = props.studentInfoList?.[0];

        if (!firstStudentInfo) {
            return;
        }

        DesktopLayerPopup.notice({
            message:
                '이미 윙크를 신청한 경험이 있는 아이입니다.</br>' +
                '아래의 버튼을 누르시면 특별 추가 무료학습 기회를 드립니다.',
            buttonLabel: '이어서 신청하기',
            callback: (type) =>
                onClickOneMoreRequest(type, [
                    makeTemporaryInformationParams(
                        firstStudentInfo,
                        'PC_WEB_재신청',
                        termsAgreementOverride
                    ),
                ]),
        });
    };

    // 이어서 신청하기 버튼 클릭 이벤트
    const onClickOneMoreRequest = (type, tempInfoParams) => {
        if (type === 'CLOSE') {
            requestTemporaryInformation(tempInfoParams);
        }
    };

    // 임시정보 등록 요청
    const requestTemporaryInformation = async (tempInfoParams) => {
        try {
            const { studentInfoList, silentUpdateMultipleList } = props;

            await Promise.all(
                tempInfoParams.map((tempInfo) => {
                    const { url, params } = api.addTemporaryInformationActor(tempInfo);
                    return silentUpdateMultipleList([
                        {
                            id: 'temporaryInformationActor',
                            url,
                            params,
                        },
                    ]);
                })
            );
            service.sendLevelChoiceGaEvent(
                studentInfoList,
                studentInfoList.map(({ checkList }) => checkList)
            );
            success();
        } catch (err) {
            console.error(err);
        }
    };

    const success = () => {
        deleteDropOut();
        successApplyExperience();

        buttonBlock.current.stop();
        clearMdnToken?.();
        clearAuthActor();
        logout();
        clearAction();

        props.history.push(routes.wink.freeStudyNotLoginComplete);
    };

    // CertStatus 변경
    const onChangeCertStatus = (certStatus) => {
        setState((prevState) => ({
            ...prevState,
            certStatus: {
                ...prevState.certStatus,
                ...certStatus,
            },
        }));
    };

    const onClickNextStep = () => {
        const isValid = checkFieldsValueStep01();
        if (!isValid) {
            return;
        }
        // 약관 UI가 1단계에 있으므로 다음 단계 진입 전에 약관 동의 검증
        validateAndShowAgreementPopup(() => setCurStep(2));
    };

    const { studentInfoList, setStudentInfoList } = props;

    return (
        <div id="contents" className="wink-free-study">
            <TrialApplyDescription />
            <div id="request-study-form-id">
                {curStep === 1 && (
                    <>
                        <div>
                            <ShippingAddressNotLogin
                                {...props}
                                clearAction={clearAction}
                                checkOneTimePasswordForMemberJoin={checkOneTimePasswordForMemberJoin}
                                phoneDuplicateCheckAndOneTimePasswordForMemberJoin={
                                    phoneDuplicateCheckAndOneTimePasswordForMemberJoin
                                }
                                existAuth={existAuth}
                                auth={auth}
                                actor={memberJoinActor}
                                action={action}
                                mdn_token={mdnToken}
                                certStatus={state.certStatus}
                                onChangeCertStatus={onChangeCertStatus}
                                buttonBlock={buttonBlock}
                            />
                            <AgreementSection agreement={termsAgreement} onCheckBox={onAgreementCheckBox} />

                            <NewBtnArea>
                                <NewBtn confirm onClick={onClickNextStep}>
                                    확인 및 다음단계
                                </NewBtn>
                            </NewBtnArea>
                        </div>
                    </>
                )}
                {curStep === 2 && (
                    <>
                        <WinkFreeStudyNotLoginStep02
                            studentInfoList={studentInfoList}
                            setStudentInfoList={setStudentInfoList}
                            studentList={studentList}
                        />
                        <NewBtnArea>
                            <NewBtn onClick={() => setCurStep(1)}>이전</NewBtn>
                            <NewBtn confirm onClick={onClickConfirm}>
                                신청 완료
                            </NewBtn>
                        </NewBtnArea>
                    </>
                )}
            </div>
        </div>
    );
};

export default ExperienceInjector(null, mapDispatchToProps)(WinkFreeStudyNotLogin);
